import Axios from "axios";
import {
    SET_PUR_PR_APPROVAL_REPORT,
    UNSET_PUR_PR_APPROVAL_REPORT,
  } from "@/store/mutation-types";
import {getPurPRApprovalReport} from "@/store/api";

const state = {
    getPurPRApprovalReport: [],
};

const getters = {
    getPurPRApprovalReport(state) {
        return state.getPurPRApprovalReport;
    },
};

const mutations = {
    [SET_PUR_PR_APPROVAL_REPORT](state, data) {
        state.getPurPRApprovalReport = data;
    },
    [UNSET_PUR_PR_APPROVAL_REPORT](state) {
        state.getPurPRApprovalReport = [];
    },
};

const actions = {
    getPurPRApprovalReport({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurPRApprovalReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_PR_APPROVAL_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_PR_APPROVAL_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

